import { createSlice } from '@reduxjs/toolkit';
import { handleRequestThunk } from '../../handleRequestThunk';
import { getEngineParts } from '../thunks/partsThunks';
import { commonInitialState } from '../../../../utils/common/commonInitialState';
import { clearPartsKey } from '../thunkKeys/partsThunksKeys';

const SLICE_NAME = 'engineParts';

export const enginePartsSlice = createSlice({
    name: SLICE_NAME,
    initialState: structuredClone(commonInitialState),
    reducers: {
        clearEngineParts(state) {
            state.data = [];
        },
    },
    extraReducers: (builder) => {
        handleRequestThunk({ builder, request: getEngineParts });
        builder.addCase(clearPartsKey, () => commonInitialState);
    },
});

export const { clearEngineParts } = enginePartsSlice.actions;

export const engineParts = enginePartsSlice.reducer;
